import React from 'react';

export default (loader, collection) => (
  class AsyncComponent extends React.Component {
    constructor(props) {
      super(props);

      this.Component = null;
      this.state = { Component: AsyncComponent.Component };
    }

    /**
     * Invoked immediately before mounting occurs, and may trigger asynchronous component loading.
     * If the component is not already loaded, it calls the loader function to dynamically import
     * the component and update the state once it is resolved.
     */

    UNSAFE_componentWillMount() {
      if (!this.state.Component) {
        loader().then((Component) => {
          AsyncComponent.Component = Component;

          this.setState({ Component });
        });
      }
    }

    /**
     * Invoked when the component is mounted and the component has been loaded.
     * If the component has been loaded, it will render the component with the
     * props and collection passed to it. If the component has not been loaded,
     * it will return null.
     */
    render() {
      if (this.state.Component) {
        return (
          <this.state.Component { ...this.props } { ...collection } />
        )
      }

      return null;
    }
  }
);
